import * as React from 'react'

export const ActivityLine = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 8h-3l-2.25 6.75-4.5-13.5L3.5 8h-3"
      stroke="#282421"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
